<template>
  <div class="tab-special-goods-ui-custom">
    <!-- 危险品 -->
    <tab-special-goods-UICustom-layout v-if="job.cargoType==='DG'" :element-blocks="elementBlocks">
      <div slot="viewAssociatedBusiness" class="section">
        <div class="operations">
          <el-button
            v-show="btnshowAWindow"
            :disabled="!!previewConfig"
            no="1"
            type="primary"
            size="mini"
            @click="showAWindowClickHandler"
          >{{ $t('SeaExport.ViewAssociatedBusiness') }}</el-button>
        </div>
      </div>
      <div v-if="elementDict.listOfHazardousMaterials.viewable" slot="listOfHazardousMaterials" class="section">
        <span class="title">{{ $t('queryJob.ListOfHazardousMaterials') }}</span>
        <div style="display:flex;flex-direction:column">
          <cargo-ag-grid
            :grid-options="danger.gridOptions"
            :grid-params.sync="danger.gridParams"
            :column-defs="dangerColumnDefs"
            :row-data="specialGoods"
            style="width:950px;height:200px"
            @gridReady="params=>danger.gridApi=params.api"
          />
          <div style="width:100%">
            <div style="float:left;padding:5px 5px 5px 0">
              <el-button no="3" type="primary" :disabled="!isEditing" @click="pm.addSpGoods()">{{ $t('SpecialGoods.Add') }}</el-button>
              <el-button no="4" type="danger" style="margin-left: 5px;" :disabled="!isEditing" @click="pm.delSpGoods()">{{ $t('SpecialGoods.Delete') }}</el-button>
              <el-upload
                :disabled="!isEditing"
                action="string"
                :http-request="importSpGoods"
                :show-file-list="false"
                accept=".jpg, .jpeg, .png"
                :before-upload="beforeUploadSpgGoods"
                style="display: inline-block;padding-left: 5px;"
              >
                <el-button :disabled="!isEditing" type="primary">{{ $t('SpecialGoods.Import') }}</el-button>
              </el-upload>
              <el-button no="5" style="margin-left: 5px;" type="primary" :disabled="!isEditing" @click="pm.fillInSpGoods()">{{ $t('SpecialGoods.FillIn') }}</el-button>
            </div>
          </div>
        </div>
      </div>
      <template>
        <el-form-item v-if="elementDict.danClassNo.viewable" slot="danClassNo">
          <line-label slot="label" :class="elementDict.danClassNo.isRequire ? 'blue' : ''" :label="elementDict.danClassNo.label" />
          <el-input v-if="!dangerousInputMode" v-model="editObj.danClassNo" no="6" :disabled="!isEditing" />
          <el-select
            v-if="dangerousInputMode"
            v-model="editObj.danClassNo"
            no="7"
            :disabled="!isEditing || !elementDict.danClassNo.writable"
            :placeholder="!isEditing ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
            clearable
            filterable
          >
            <el-option
              v-for="(item,index) in danClassNos"
              :key="index"
              :label="isZh ? item.chineseName : item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.secondarySpecialGoods.viewable" slot="secondarySpecialGoods">
          <line-label slot="label" :class="elementDict.secondarySpecialGoods.isRequire ? 'blue' : ''" :label="elementDict.secondarySpecialGoods.label" />
          <el-input v-model="editObj.secondarySpecialGoods" no="8" :disabled="!isEditing || !elementDict.secondarySpecialGoods.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.danUNNo.viewable" slot="danUNNo">
          <line-label slot="label" :class="elementDict.danUNNo.isRequire ? 'blue' : ''" :label="elementDict.danUNNo.label" />
          <el-select
            ref="danUNNo"
            v-model="editObj.danUNNo"
            no="9"
            :disabled="!isEditing || !elementDict.danUNNo.writable"
            :placeholder="!isEditing ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
            filterable
            clearable
            :allow-create="true"
            @blur="txtdDnUNNoFocusOutHandler()"
          >
            <el-option
              v-for="(item,index) in dangerousGoods"
              :key="index"
              :label="item.code"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.danPacking.viewable" slot="danPacking">
          <line-label slot="label" :class="elementDict.danPacking.isRequire ? 'blue' : ''" :label="elementDict.danPacking.label" />
          <el-input v-if="!dangerousInputMode" v-model="editObj.danPacking" no="10" :disabled="!isEditing" />
          <el-select
            v-if="dangerousInputMode"
            v-model="editObj.danPacking"
            no="11"
            :disabled="!isEditing || !elementDict.danPacking.writable"
            :placeholder="!isEditing ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
            clearable
          >
            <el-option
              v-for="(item,index) in packingGoods"
              :key="index"
              :label="isZh ? item.chineseName : item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.danLable.viewable" slot="danLable">
          <line-label slot="label" :class="elementDict.danLable.isRequire ? 'blue' : ''" :label="elementDict.danLable.label" />
          <el-input v-model="editObj.danLable" no="12" :disabled="!isEditing || !elementDict.danLable.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.danEMS.viewable" slot="danEMS">
          <line-label slot="label" :class="elementDict.danEMS.isRequire ? 'blue' : ''" :label="elementDict.danEMS.label" />
          <el-input v-model="editObj.danEMS" no="13" :disabled="!isEditing || !elementDict.danEMS.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.danPoint.viewable" slot="danPoint">
          <line-label slot="label" :class="elementDict.danPoint.isRequire ? 'blue' : ''" :label="elementDict.danPoint.label" />
          <el-input v-model="editObj.danPoint" no="14" style="width: 85%;display: inline-block" :disabled="!isEditing" />
          <el-select
            v-model="editObj.flashPointUnit"
            :disabled="!isEditing || !elementDict.danPoint.writable"
            no="flashPointUnit"
            style="width: 15%;display: inline-block"
            placeholder=""
          >
            <el-option
              v-for="(item,index) in flashPointUnitArray"
              :key="index"
              :label="isZh ? item.chineseName : item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.temperatureUnit.viewable && dangerousInputMode" slot="temperatureUnit">
          <line-label slot="label" :class="elementDict.temperatureUnit.isRequire ? 'blue' : ''" :label="elementDict.temperatureUnit.label" />
          <el-select
            v-model="editObj.temperatureUnit"
            no="15"
            :disabled="!isEditing || !elementDict.temperatureUnit.writable"
            :placeholder="!isEditing ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
            :clearable="false"
          >
            <el-option
              v-for="(item,index) in temperatureUnits"
              :key="index"
              :label="isZh ? item.chineseName : item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.danIsolation.viewable" slot="danIsolation" class="bold">
          <line-label slot="label" :class="elementDict.danIsolation.isRequire ? 'blue' : ''" :label="elementDict.danIsolation.label" />
          <el-input v-model="editObj.danIsolation" no="16" :disabled="!isEditing || !elementDict.danIsolation.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.danMfagNo.viewable" slot="danMfagNo">
          <line-label slot="label" :class="elementDict.danMfagNo.isRequire ? 'blue' : ''" :label="elementDict.danMfagNo.label" />
          <el-input v-model="editObj.danMfagNo" no="17" :disabled="!isEditing || !elementDict.danMfagNo.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.dan24man.viewable" slot="dan24man">
          <line-label slot="label" :class="elementDict.dan24man.isRequire ? 'blue' : ''" :label="elementDict.dan24man.label" />
          <el-input v-model="editObj.dan24man" no="18" :disabled="!isEditing || !elementDict.dan24man.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.dan24tel.viewable" slot="dan24tel">
          <line-label slot="label" :class="elementDict.dan24tel.isRequire ? 'blue' : ''" :label="elementDict.dan24tel.label" />
          <el-input v-model="editObj.dan24tel" no="19" :disabled="!isEditing || !elementDict.dan24tel.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.email.viewable" slot="email">
          <line-label slot="label" :class="elementDict.email.isRequire ? 'blue' : ''" :label="elementDict.email.label" />
          <el-input v-model="editObj.email" no="email" :disabled="!isEditing || !elementDict.email.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.fax.viewable" slot="fax">
          <line-label slot="label" :class="elementDict.fax.isRequire ? 'blue' : ''" :label="elementDict.fax.label" />
          <el-input v-model="editObj.fax" no="fax" :disabled="!isEditing || !elementDict.fax.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.responsibleParty.viewable" slot="responsibleParty">
          <line-label slot="label" :class="elementDict.responsibleParty.isRequire ? 'blue' : ''" :label="elementDict.responsibleParty.label" />
          <el-input v-model="editObj.responsibleParty" :disabled="!isEditing || !elementDict.responsibleParty.writable" no="20" style="width:215px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.hsCode.viewable" slot="hsCode">
          <line-label slot="label" :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
          <el-input v-model="editObj.hsCode" :disabled="!isEditing || !elementDict.hsCode.writable" no="21" style="width:215px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.danPickTime.viewable" slot="danPickTime">
          <line-label slot="label" :class="elementDict.danPickTime.isRequire ? 'blue' : ''" :label="elementDict.danPickTime.label" />
          <el-input v-model="editObj.danPickTime" :disabled="!isEditing || !elementDict.danPickTime.writable" no="22" style="width:215px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.danSeaPullution.viewable" slot="danSeaPullution">
          <line-label slot="label" :class="elementDict.danSeaPullution.isRequire ? 'blue' : ''" :label="elementDict.danSeaPullution.label" />
          <el-input v-model="editObj.danSeaPullution" :disabled="!isEditing || !elementDict.danSeaPullution.writable" no="23" :placeholder="!isEditing ? '' : $t('SpecialGoods.OnlyEnterYN')" style="width:215px;" @change="limitInput" />
        </el-form-item>
        <el-form-item v-if="elementDict.correctTransportName.viewable" slot="correctTransportName">
          <line-label slot="label" :class="elementDict.correctTransportName.isRequire ? 'blue' : ''" :label="elementDict.correctTransportName.label" />
          <el-input v-model="editObj.correctTransportName" :disabled="!isEditing || !elementDict.correctTransportName.writable" no="24" style="width:215px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.grossWeight.viewable" slot="grossWeight">
          <line-label slot="label" :class="elementDict.grossWeight.isRequire ? 'blue' : ''" :label="elementDict.grossWeight.label" />
          <el-input-number v-model="editObj.grossWeight" :disabled="!isEditing || !elementDict.grossWeight.writable" no="25" :min="0" :max="999999999999" :precision="3" controls-position="right" style="width:215px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.neatWeight.viewable" slot="neatWeight">
          <line-label slot="label" :class="elementDict.neatWeight.isRequire ? 'blue' : ''" :label="elementDict.neatWeight.label" />
          <el-input-number v-model="editObj.neatWeight" :disabled="!isEditing || !elementDict.neatWeight.writable" no="26" :min="0" :max="999999999999" :precision="3" controls-position="right" style="width:215px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.outerPackagingType.viewable" slot="outerPackagingType">
          <line-label slot="label" :class="elementDict.outerPackagingType.isRequire ? 'blue' : ''" :label="elementDict.outerPackagingType.label" />
          <el-input v-model="editObj.outerPackagingType" :disabled="!isEditing || !elementDict.outerPackagingType.writable" no="27" :style="isEditing ? 'width:170px': 'width:215px'" />
          <!--危险品包装-->
          <span v-if="isEditing" class="el-button el-button--primary el-button--mini" style="min-width:40px!important;margin-left:2px" @click="queryDangerousGoodPackageHandle('outerPackagingType')"><i class="el-icon-search" /></span>
        </el-form-item>
        <el-form-item v-if="elementDict.outerPackagingQuantity.viewable" slot="outerPackagingQuantity">
          <line-label slot="label" :class="elementDict.outerPackagingQuantity.isRequire ? 'blue' : ''" :label="elementDict.outerPackagingQuantity.label" />
          <el-input-number v-model="editObj.outerPackagingQuantity" :disabled="!isEditing || !elementDict.outerPackagingQuantity.writable" no="28" :min="0" :max="999999999999" controls-position="right" style="width:215px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.innerPackagingType.viewable" slot="innerPackagingType">
          <line-label slot="label" :class="elementDict.innerPackagingType.isRequire ? 'blue' : ''" :label="elementDict.innerPackagingType.label" />
          <el-input v-model="editObj.innerPackagingType" :disabled="!isEditing || !elementDict.innerPackagingType.writable" no="29" :style="isEditing ? 'width:170px': 'width:215px'" />
          <!--危险品包装-->
          <span v-if="isEditing" class="el-button el-button--primary el-button--mini" style="min-width:40px!important;margin-left:2px" @click="queryDangerousGoodPackageHandle('innerPackagingType')"><i class="el-icon-search" /></span>
        </el-form-item>
        <el-form-item v-if="elementDict.innerPackagingQuantity.viewable" slot="innerPackagingQuantity">
          <line-label slot="label" :class="elementDict.innerPackagingQuantity.isRequire ? 'blue' : ''" :label="elementDict.innerPackagingQuantity.label" />
          <el-input-number v-model="editObj.innerPackagingQuantity" :disabled="!isEditing || !elementDict.innerPackagingQuantity.writable" no="30" :min="0" :max="999999999999" :precision="0" controls-position="right" style="width:215px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.remark.viewable" slot="remark">
          <line-label slot="label" :class="elementDict.remark.isRequire ? 'blue' : ''" :label="elementDict.remark.label" />
          <el-input v-model="editObj.remark" :disabled="!isEditing || !elementDict.remark.writable" no="31" type="textarea" :rows="2" style="width:215px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.packingCode.viewable" slot="packingCode">
          <line-label slot="label" :class="elementDict.packingCode.isRequire ? 'blue' : ''" :label="elementDict.packingCode.label" />
          <el-input v-model="editObj.packingCode" :disabled="!isEditing || !elementDict.packingCode.writable" no="32" style="width:215px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.hazardForm && elementDict.hazardForm.viewable" slot="hazardForm">
          <line-label slot="label" :class="elementDict.hazardForm.isRequire ? 'blue' : ''" :label="elementDict.hazardForm.label" />
          <el-select v-model="editObj.hazardForm" :disabled="!isEditing || !elementDict.hazardForm.writable" no="hazardForm" style="width:215px;" placeholder="">
            <el-option
              v-for="(item,index) in hazardFormArray"
              :key="index"
              :label="isZh ? item.chineseName : item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.emergencyReportingTime && elementDict.emergencyReportingTime.viewable" slot="emergencyReportingTime">
          <line-label slot="label" :class="elementDict.emergencyReportingTime.isRequire ? 'blue' : ''" :label="elementDict.emergencyReportingTime.label" />
          <el-date-picker
            v-model="editObj.emergencyReportingTime"
            no="emergencyReportingTime"
            :disabled="!isEditing || !elementDict.emergencyReportingTime.writable"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 100%"
          />
        </el-form-item>
      </template>
      <div v-if="elementDict.containerInfo.viewable" slot="containerInfo" class="section">
        <span class="title">{{ $t('SeaExport.ContainerInfo') }}</span>
        <div style="display:flex;flex-direction:column">
          <div style="padding:5px 0">
            <div>
              <el-button no="33" :disabled="!!previewConfig || isEditing" type="primary" @click="pm.linkUsageClickHandler()">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
              <el-button no="34" :disabled="!!previewConfig || isEditing" type="danger" @click="pm.delLinkUsageClickHandler()">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
            </div>
            <div style="flex:1;display:flex;justify-content:flex-end;padding-right:100px">
              <el-button no="55" :disabled="!isEditing" type="primary" @click="handleAutoDistribute">{{ $t('SeaExport.AutoAllocation') }}</el-button>
            </div>
          </div>
          <cargo-ag-grid
            no="35"
            config-module="20000"
            :grid-options="box.gridOptions"
            :grid-params.sync="box.gridParams"
            :column-defs="boxColumnDefs"
            :row-data="containerUsages"
            style="width:100%;height:220px"
            @gridReady="params=>box.gridApi=params.api"
          />
        </div>
      </div>
    </tab-special-goods-UICustom-layout>
    <!-- 挂衣箱 -->
    <div v-if="job.cargoType==='GOH'" class="section">
      <span class="title">{{ $t('SpecialGoods.GOH') }}</span>
      <div style="display:flex;flex-direction:column">
        <div style="display:flex;flex-direction:row">
          <span style="width:100px">{{ $t('SpecialGoods.Tier') }}</span>
          <span style="width:190px">{{ $t('SpecialGoods.Hanger') }}</span>
          <span style="width:190px">{{ $t('SpecialGoods.Ropes') }}</span>
          <span style="width:190px">{{ $t('SpecialGoods.Knots') }}</span>
        </div>
        <div style="display:flex;flex-direction:row">
          <el-input v-model="editObj.gohTier" no="36" style="width:90px;margin-right:10px" :disabled="!isEditing" />
          <el-input v-model="editObj.gohHanger" no="37" style="width:180px;margin-right:10px" :disabled="!isEditing" />
          <el-input v-model="editObj.gohRopes" no="38" style="width:180px;margin-right:10px" :disabled="!isEditing" />
          <el-input v-model="editObj.gohKnots" no="39" style="width:180px" :disabled="!isEditing" />
        </div>
        <div style="display:flex;flex-direction:row;margin-top: 10px;">
          <span style="width:100px">{{ $t('SpecialGoods.ReformCost') }}</span>
          <el-input v-model="editObj.gohReformCost" no="40" style="width:180px" :disabled="!isEditing" />
        </div>
      </div>
    </div>
    <!-- 冷藏箱 -->
    <div v-show="job.cargoType==='RF'" class="section">
      <span class="title">{{ $t('SpecialGoods.Reefer') }}</span>
      <div style="display:flex;flex-direction:column">
        <el-form :inline="true" label-width="95px" label-position="left">
          <el-form-item>
            <div style="display: flex;align-items: center">
              <span slot="label">{{ $t('SpecialGoods.humidity') }}</span>
              <el-tooltip
                :content="$t('SpecialGoods.HumidityToolTip')"
                placement="right-end"
              >
                <img
                  :src="humidityToolTip"
                  width="18"
                  height="28"
                  style="padding: 5px 0;vertical-align: bottom;"
                >
              </el-tooltip>
              <el-input v-model="editObj.reefHumidity" no="41" style="width:160px" :maxlength="8" :disabled="!isEditing" />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.ventilation')">
            <el-input v-model="editObj.reefVentilation" no="42" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
        <el-form :inline="true" label-width="95px" label-position="left">
          <el-form-item :label="$t('SeaExport.SetTemperature')">
            <el-input v-model="editObj.reefTemperature" no="43" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MinimumTemperature')">
            <el-input v-model="editObj.reefLowestTemp" no="44" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MaximumTemperature')">
            <el-input v-model="editObj.reefHighestTemp" no="45" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
        <el-form :inline="true" label-width="95px" label-position="left">
          <el-form-item :label="$t('SpecialGoods.ContainerYard')">
            <el-input v-model="editObj.reefContainerYard" no="46" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.TemperatureUnit')">
            <el-select
              v-model="editObj.temperatureUnit"
              no="47"
              :disabled="!isEditing"
              :clearable="false"
              style="width:160px"
            >
              <el-option
                v-for="(item,index) in temperatureUnits"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <el-form :inline="true" label-width="95px" label-position="left">
          <el-form-item :label="$t('SeaExport.PortForReturningContainer')">
            <el-input v-model="editObj.reefDeliverTime" no="48" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
        <el-form :inline="true" label-width="95px" label-position="left">
          <el-form-item :label="$t('SpecialGoods.PTI')">
            <el-input v-model="editObj.reefPTI" no="49" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 加非标准箱 -->
    <div v-show="job.cargoType==='BB'" class="section">
      <span class="title">{{ $t('SeaExport.NonStandardContainer') }}</span>
      <div style="display:flex;flex-direction:column">
        <el-form :inline="true" label-width="40px" label-position="left">
          <el-form-item :label="$t('SeaExport.OverFront')">
            <el-input-number v-model="editObj.overFront" no="50" :controls="false" :min="0" :precision="0" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverBack')">
            <el-input-number v-model="editObj.overBack" no="51" :controls="false" :min="0" :precision="0" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverHeight')">
            <el-input-number v-model="editObj.overHeight" no="52" :controls="false" :min="0" :precision="0" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
        <el-form :inline="true" label-width="40px" label-position="left">
          <el-form-item :label="$t('SeaExport.OverLeft')">
            <el-input-number v-model="editObj.overLeft" no="53" :controls="false" :min="0" :precision="0" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverRight')">
            <el-input-number v-model="editObj.overRight" no="54" :controls="false" :min="0" :precision="0" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 选择装箱信息弹窗 -->
    <special-goods-container-usage-dialog
      :visible.sync="containerUsageDialog.visible"
      :job-uuid="job.uuid"
      @linkUsagesEventHandler="linkUsagesEventHandler"
    />
    <!-- 危险品-关联业务 -->
    <special-goods-dialog
      :visible.sync="specialGoodsDialog.visible"
      :a-data="specialGoodsDialog.aData"
      :o-job="specialGoodsDialog.oJob"
      :job="specialGoodsDialog.job"
      @refreshCache="refreshCache"
    />
    <imdg-code-select-dialog
      :visible.sync="imdgCodeSelDialog.visible"
      :imdg-codes="imdgCodeSelDialog.imdgCodes"
      @onImdgCodeSelSucceed="onImdgCodeSelSucceed"
    />
    <!--    危险品包装-->
    <dangerous-good-package-dialog
      :visible.sync="dangerousGoodsDialog.visible"
      :type="dangerousGoodsDialog.type"
      @dangerousGoodPackage="dangerousGoodPackageCallBack"
      @close="dangerousGoodsDialog.visible=false"
    />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabSpecialGoodsUICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabSpecialGoodsUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabSpecialGoods from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabSpecialGoods'
import StrUtils from '@/utils/StrUtils'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'

export default {
  name: 'TabSpecialGoodsUICustom',
  components: { cargoAdvanceSelect, tabSpecialGoodsUICustomLayout },
  extends: tabSpecialGoods,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      flashPointUnitArray: SeaExportConstants.REEF_TEMP_UNITS,
      hazardFormArray: SeaExportConstants.HAZARD_FORM_ARR
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_SPECIAL_GOODS, this.elementDict, row)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
        this.job.cargoType = 'DG'
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_SPECIAL_GOODS, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    validateFormItem(item) {
      for (const name in this.elementDict) {
        const element = this.elementDict[name]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          const label = element.fieldNames.length > 1 ? field.label : element.label
          if (typeof item[fieldName] !== 'boolean' && StrUtils.isEmpty(item[fieldName])) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabSpecialGoods')
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  .tab-special-goods-ui-custom::v-deep {
    .bold {
      .el-form-item__label {
        font-weight: bold;
        font-size: 14px;
      }
    }
  }
}
</style>
